import cx from 'classnames';
import React from 'react';
import { useRootPreviewType } from 'js/file_viewer/api/data';
import { PreviewType } from 'js/file_viewer/core/types/preview_type';
import { useMouseActive } from 'js/file_viewer/hooks/use_mouse_active';
import { FullscreenButton } from 'js/file_viewer/toolbar/fullscreen_button';
import { SlideshowControls } from 'js/file_viewer/toolbar/slideshow_controls';
import { SHOW_TOOLS_HIDE_AFTER_MS } from 'js/file_viewer/ui/constants';
import * as css from 'js/file_viewer/ui/fullscreen_right_section.module.css';
import { HideToolbarButton } from 'js/file_viewer/ui/hide_toolbar_button';
export const FullscreenRightSection = () => {
    const { isUserInteractingWithElement, handleBlur, handleFocus } = useMouseActive(SHOW_TOOLS_HIDE_AFTER_MS);
    const previewType = useRootPreviewType();
    const isAudioVideo = previewType === PreviewType.Video || previewType === PreviewType.Audio;
    return (React.createElement("div", { className: cx(css.fullscreenRightSection, {
            [css.hidden]: !isUserInteractingWithElement,
        }), onBlur: handleBlur, onFocus: handleFocus },
        React.createElement(SlideshowControls, { previewType: previewType }),
        React.createElement(HideToolbarButton, null),
        !isAudioVideo && React.createElement(FullscreenButton, { variant: 'borderless' })));
};
FullscreenRightSection.displayName = "FullscreenRightSection"
//# sourceMappingURL=fullscreen_right_section.preenvesnextjs.map
